import { render } from "./IframeVideoPlayer.vue?vue&type=template&id=74a0ea02&scoped=true"
import script from "./IframeVideoPlayer.vue?vue&type=script&lang=ts"
export * from "./IframeVideoPlayer.vue?vue&type=script&lang=ts"

import "./IframeVideoPlayer.vue?vue&type=style&index=0&id=74a0ea02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74a0ea02"

export default script